<!--
 @description 集群管理-首页
 @author xiehan
 @date 2018/10/11
-->
<template>
  <div class="clusterManager__content">
    <el-button type="primary" 
      @click="addCluster" 
      v-g-rac="gRac('clusterManager@add')" 
      v-text="$t('clusterManager.addCluster')"></el-button>
    <el-button type="primary" 
      @click="deleteCluster" 
      v-g-rac="gRac('clusterManager@delete')" 
      v-text="$t('clusterManager.deleteCluster')"></el-button>
    <div class="mt-base">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
        <el-form-item>
          <el-input v-model="searchForm.clusterName" :placeholder="$t('clusterManager.clusterName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="search(true)" 
            v-g-rac="gRac('clusterManager@search')" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table-extend
      :cell-style="cellStyle"
      :cell-click="cellClick"
      :data="tableData"
      :head="tableHead"
      :selection="true"
      :selectionChange="tableSelect"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
      </el-table-extend>
    </div>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import ClusterManagerBiz from '@/logic/continuousDelivery/clusterManagerBiz'
  import TimeFormat from '@/utils/timeFormat'

  export default {
    mixins: [rac, dic],
    data () {
      return {
        searchForm: {
          clusterName: ''
        },
        tableData: {},
        tableHead: [],
        select_envType: {},
        currentPage: 1,
        perPageCount: 10,
        tableSelectList: []
      }
    },
    components: {},
    methods: {
      search (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        if (this.searchForm.clusterName) searchObj.clusterName = this.searchForm.clusterName
        ClusterManagerBiz.getCluster(searchObj).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
            })
          }
          this.tableData = data
        })
      },
      initTable () {
        this.tableHead = [
          { key: 'clusterName', label: this.$t('clusterManager.table.clusterName'), showOverflowTooltip: true, width: '180px' },
          { key: 'envType',
            label: this.$t('clusterManager.table.envType'),
            formatter: 'Dictionary',
            formatterDic: this.select_envType,
            width: '80px' },
          { key: 'operator', label: this.$t('clusterManager.table.operator'), width: '130px' },
          { key: 'tester', label: this.$t('clusterManager.table.tester'), width: '130px' },
          { key: 'creator', label: this.$t('clusterManager.table.creator'), width: '130px' },
          { key: 'createTime', label: this.$t('clusterManager.table.createTime'), width: '146px' },
          { key: 'remarks', label: this.$t('clusterManager.table.remarks'), showOverflowTooltip: true }
        ]
      },
      addCluster () {
        this.$router.push({ name: 'handlerCluster' })
      },
      deleteCluster () {
        if (this.tableSelectList.length === 0) {
          this.$message({
            message: this.$t('common.selectTips'),
            type: 'warning'
          })
          return
        }
        let idList = this.tableSelectList.map(item => item.id)
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          ClusterManagerBiz.deleteCluster({ clusters: idList }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {})
      },
      async waitEnvType () {
        await this.dGetDictionaryByCode('envType')
        this.select_envType = { ...this.dDictionary.envType }
        this.initTable()
        this.search()
      },
      cellStyle ({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return 'color:#0B8DE5; cursor:pointer'
        }
      },
      cellClick (row, columnKey) {
        if (columnKey === 'clusterName') {
          this.$router.push({ name: 'handlerCluster', query: { id: row.id } })
        }
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      },
      tableSelect (val) {
        this.tableSelectList = val
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'clusterManager' && from.name === 'handlerCluster') {
          this.waitEnvType()
        }
      }
    },
    mounted () {
      this.waitEnvType()
    }
  }
</script>

<style scoped>
</style>